module.exports = function getResource(label, vars = []) {
    let resources = {
        reviewRecentPurchases: 'Review Recent Purchases'
    };
    return resources[label];
};
